import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck, Check } from 'lucide-react';
export function PricingCTA() {
  return <section id="pricing" className="py-24 px-4 bg-white relative overflow-hidden" data-id="element-184">
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-185">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-warm-gradient p-8 md:p-16 rounded-[2.5rem] shadow-2xl border border-white" data-id="element-186">
          <h2 className="text-3xl md:text-5xl font-bold text-brown mb-8" data-id="element-187">
            ¿Cuánto vale tu paz mental?
          </h2>

          <div className="bg-white/50 rounded-2xl p-6 mb-8 max-w-lg mx-auto text-left space-y-4" data-id="element-188">
            <div className="flex justify-between items-center border-b border-brown/10 pb-2" data-id="element-189">
              <span className="text-brown-light" data-id="element-190">
                Guía completa Acuerdos Express
              </span>
              <span className="font-bold text-brown" data-id="element-191">$9 USD</span>
            </div>
            <div className="flex justify-between items-center border-b border-brown/10 pb-2" data-id="element-192">
              <span className="text-brown-light" data-id="element-193">Guiones de conversación</span>
              <span className="font-bold text-brown" data-id="element-194">$4 USD</span>
            </div>
            <div className="flex justify-between items-center border-b border-brown/10 pb-2" data-id="element-195">
              <span className="text-brown-light" data-id="element-196">Plantillas rellenables</span>
              <span className="font-bold text-brown" data-id="element-197">$4 USD</span>
            </div>
            <div className="flex justify-between items-center border-b border-brown/10 pb-2" data-id="element-198">
              <span className="text-brown-light" data-id="element-199">Checklist imprimible</span>
              <span className="font-bold text-brown" data-id="element-200">$4 USD</span>
            </div>
            <div className="flex justify-between items-center pt-2 text-lg" data-id="element-201">
              <span className="font-bold text-brown" data-id="element-202">VALOR TOTAL</span>
              <span className="font-bold text-brown line-through decoration-red-500 decoration-2" data-id="element-203">
                $21 USD
              </span>
            </div>
          </div>

          <div className="flex items-center justify-center gap-4 mb-8" data-id="element-204">
            <div className="text-center" data-id="element-205">
              <span className="block text-sm font-bold text-brown-light uppercase tracking-wider mb-1" data-id="element-206">
                Tu precio hoy
              </span>
              <span className="text-6xl md:text-7xl font-bold text-terracotta" data-id="element-207">
                $9
              </span>
              <span className="text-xl font-bold text-terracotta ml-1" data-id="element-208">
                USD
              </span>
            </div>
          </div>

          <p className="text-lg text-brown-light mb-8 max-w-xl mx-auto" data-id="element-209">
            Puedes seguir "intentando hablar" gratis (y pagando el precio con tu
            estrés). O puedes pagar $19 y tener un sistema que funciona hoy
            mismo. <br data-id="element-210" />
            <span className="font-bold" data-id="element-211">
              Menos de lo que cuesta pedir una pizza para no cocinar porque
              están peleados.
            </span>
          </p>

          <motion.a href="https://novarapress.com/cart/46289057742988:1" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="w-full md:w-auto px-10 py-5 bg-terracotta text-white rounded-full font-bold text-xl shadow-lg shadow-terracotta/30 hover:bg-terracotta-dark transition-colors flex items-center justify-center gap-3 mx-auto mb-8 cursor-pointer" onClick={() => {
          if (window.fbq) {
            window.fbq('track', 'AddToCart', {
              content_name: 'Acuerdos Express',
              content_type: 'product',
              value: 19.0,
              currency: 'USD'
            });
          }
        }} data-id="element-212">
            Quiero el Sistema Acuerdos Express
            <ArrowRight className="w-6 h-6" data-id="element-213" />
          </motion.a>

          <div className="bg-white/60 rounded-xl p-6 mb-8 border border-white" data-id="element-214">
            <div className="flex items-center justify-center gap-2 mb-4" data-id="element-215">
              <ShieldCheck className="w-6 h-6 text-terracotta" data-id="element-216" />
              <h3 className="font-bold text-brown text-lg" data-id="element-217">
                Garantía Total de 7 Días — Sin Preguntas
              </h3>
            </div>
            <p className="text-sm text-brown-light leading-relaxed" data-id="element-218">
              Pruébalo. Úsalo en tu próxima discusión. Si no sientes que te
              quita un peso de encima inmediatamente, te devuelvo tu dinero. Sin
              preguntas incómodas. El riesgo es mío.
            </p>
          </div>

          <div className="space-y-4 text-brown-light max-w-2xl mx-auto border-t border-brown/10 pt-8" data-id="element-219">
            <p className="font-bold text-brown text-lg" data-id="element-220">
              La próxima discusión ya viene en camino.
            </p>
            <p data-id="element-221">
              Puede ser esta noche. Puede ser mañana. La pregunta es: ¿Vas a
              improvisar otra vez y esperar que salga bien? ¿O vas a tener un
              plan?
            </p>
            <p className="font-serif italic text-xl text-terracotta" data-id="element-222">
              "Tu relación es demasiado importante para dejarla a la suerte."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}